"use client";

import dynamic from "next/dynamic";

const BackToTopButton = dynamic(() => import("./BackToTopButton"), { ssr: false });
const ToastContainer = dynamic(
    () => import("react-toastify").then((mod) => mod.ToastContainer),
    { ssr: false }
);

const Theme11ClientChrome = () => {
    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={2500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
            />
            <BackToTopButton />
        </>
    );
};

export default Theme11ClientChrome;
